module.exports = __webpack_public_path__ + "static/media/artist_lop-y_w.8611f017.png";